import { useEffect, useState } from "react";
import { api } from "@/services/api";

import { Dissertacao } from "@/@types/PosGraduacao/ListaDissertacoesTeses";
import DissertacoesTesesAgendas from "@/components/PagesComponents/PosGraduacao/DissertacoesTesesAgendadas";



export function  ListaDissertacoesTeses() {
    const [dissertacoes, setDissertacoes] =  useState<Dissertacao[]>([]);

    const getDissertacoes = async() => {

        await api.get(`/posgraduacao/pospedidodefesa/allagendadefesa`)
            .then( (response ) => {
                setDissertacoes(response.data)  
            }).catch( ( error ) =>{
                if (error.response){
                    return console.log(`Erro: ${error.response}`)
                } else {
                    console.log('Erro: tente mais tarde !!!')
                }
            })
    }

    useEffect(() => {
        getDissertacoes();
    }, []);

    return(
        <>
            <h1>Pós-Graduação - Dissertações e Teses Agendadas</h1>
            <DissertacoesTesesAgendas dissertacoes={dissertacoes} />
        </>
    )
}